import {Vue} from 'ui.vue';
import './main.sass';
import Map from '../../map/src/map';
import Select from '../../../common/select/src/select';
import AutocompleteAccrual from '../../../common/autocomplete-accrual/src/autocomplete-accrual';
import BasicInputSearch from '../../../common/basic-input-search/src/basic-input-search';

Vue.component('dealers-list', {
	data() {
		return {
			dealerType: 'Dealer',
			teceOffices: [],
			filteredTeceOffices: [],
			dealers: [],
			filteredDealers: [],
			chosenOffices: [],
			map: true,
			clicked: false,
			isMapEnabled: true,
			countries: [
				{
					id: 0,
					value: 'Россия'
				}
			],
			cities: [],
			availableLocations: [],
			isShared: true
		};
	},

	computed: {
		window() {
			return window;
		}
	},

	template: `
		<div class="dealers-list">
			<div class="loading-wrapper">
				<div class="dealers-list__filters">
					<AutocompleteAccrual
						:showMagnifier="true"
						title="Введите город или регион"
						ref="autocomplete"
						@change="changeLocation"
						:availableLocations="availableLocations"
					/>
					<BasicInputSearch
						:showMagnifier="true"
						title="Поиск дилера"
						ref="dealerReset"
						:isDealersList="true"
						@change="searchQuery"
					/>
				</div>
				<div class="dealers-list__switchers">
					<div class="dealers-list__switcher dealers-list__switcher--left">
						<button
							class="dealers-list__switcher-button"
							:class="{ 'dealers-list__switcher-button--active': dealerType === 'Dealer' }"
							type="button"
							@click="changeType('Dealer')"
						>
							<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path d="M5.33627 16.0002L2.50631 14.3769C2.39752 14.3145 2.30065 14.2279 2.22136 14.122C2.14206 14.0162 2.08194 13.8933 2.04449 13.7606C2.00704 13.6278 1.99302 13.4878 2.00324 13.3488C2.01346 13.2097 2.04772 13.0744 2.10403 12.9507L4.91971 6.76461C5.03085 6.52041 5.22115 6.33605 5.44962 6.25124C5.67808 6.16642 5.92645 6.18793 6.14123 6.31113L9 7.95096L5.33627 16.0002Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
								<path d="M27.1998 16.1273L25.1634 18.3507L20.4802 22.7217C20.3558 22.8377 20.2014 22.9217 20.032 22.9655C19.8625 23.0093 19.6838 23.0114 19.5133 22.9716L12.1369 21.2505C11.9986 21.2182 11.869 21.1592 11.7567 21.0772L4.7998 16" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
								<path d="M24.3998 17.4L19.0598 14.04L17.5064 15.048C16.8341 15.4842 16.0165 15.72 15.1762 15.72C14.3359 15.72 13.5183 15.4842 12.846 15.048L12.1882 14.6211C12.0769 14.5489 11.9848 14.4569 11.9183 14.3512C11.8517 14.2455 11.8121 14.1287 11.8022 14.0087C11.7924 13.8886 11.8125 13.7681 11.8611 13.6554C11.9097 13.5426 11.9858 13.4402 12.0842 13.3551L16.8337 9.24603C16.9238 9.16803 17.0308 9.10616 17.1486 9.06394C17.2664 9.02173 17.3927 9 17.5202 9H22.458" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
								<path d="M9 8.81668L15.2869 6.25494C15.5115 6.16343 15.7521 6.18722 15.9652 6.32201L20.2 9.0002" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
								<path d="M14.5996 25.8001L10.8322 24.7036C10.6793 24.6591 10.5376 24.5732 10.4187 24.4528L7.59961 21.6001" stroke="currentColor" stroke-width="2" stroke-linecap="square" stroke-linejoin="round"/>
							</svg>
							<span class="dealers-list__switcher-button-text">Дилеры TECE CLUB</span>
						</button>
						<button
							class="dealers-list__switcher-button"
							:class="{ 'dealers-list__switcher-button--active': dealerType === 'TECE' }"
							type="button"
							@click="changeType('TECE')"
						>
							<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path d="M27 27.0001V14.4425L15.9993 4.35059L5 14.4424L5.00001 27.0001" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
								<path d="M2 27H30" stroke="currentColor" stroke-width="2" stroke-linecap="square" stroke-linejoin="round"/>
								<path d="M18.999 26.9991V18.999L12.999 18.9991L12.9998 19.0002L12.999 26.9991" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
							</svg>
							<span class="dealers-list__switcher-button-text">Офисы ТECE</span>
						</button>
					</div>
					<div class="dealers-list__control-buttons">
						<div class="dealers-list__sort">
							<button
								class="dealers-list__sort-button"
								:class="{ 'dealers-list__sort-button--active': clicked }"
								type="button"
								@click="sortClick"
							>
							</button>
						</div>
						<div class="dealers-list__switcher">
							<button
								class="dealers-list__switcher-button dealers-list__switcher-button--centered"
								:class="{ 'dealers-list__switcher-button--active': !map }"
								:disabled="!map"
								type="button"
								@click="switcher"
							>
								<svg width="21" height="16" viewBox="0 0 21 16" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path d="M0 1H20.32M0 14.5467H20.32M0 7.77337H20.32" stroke="currentColor" stroke-width="2"/>
								</svg>
							</button>
							<button
								class="dealers-list__switcher-button dealers-list__switcher-button--centered"
								:class="{ 'dealers-list__switcher-button--active': map }"
								:disabled="map"
								type="button"
								@click="switcher"
							>
								<svg width="20" height="25" viewBox="0 0 20 25" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path fill-rule="evenodd" clip-rule="evenodd" d="M19 9.65385C19 17.4423 10 23.5 10 23.5C10 23.5 1 17.4423 1 9.65385C1 7.3587 1.94821 5.15756 3.63604 3.53465C5.32387 1.91174 7.61305 1 10 1C12.3869 1 14.6761 1.91174 16.364 3.53465C18.0518 5.15756 19 7.3587 19 9.65385ZM10 13.1154C11.9882 13.1154 13.6 11.5656 13.6 9.65385C13.6 7.74209 11.9882 6.19231 10 6.19231C8.01177 6.19231 6.4 7.74209 6.4 9.65385C6.4 11.5656 8.01177 13.1154 10 13.1154Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
								</svg>
							</button>
						</div>
					</div>
				</div>
				<div class="dealers-list__body">
					<Map v-if="map" :dealerType="dealerType" :offices="chosenOffices" />
					<template v-else>
						<div class="dealers-list__wrapper" v-if="dealerType === 'TECE'">
							<ul class="dealers-list__list">
								<li class="dealers-list__item">
									<div class="dealers-list__title-wrapper">
										<p class="dealers-list__title">TECE</p>
										<a target="_blank" :href="window.TECE.DILLERS.filter(item => item.NAME === 'TECE')[0].UF_URL_SITE" class="dealers-list__link">
											<span class="dealers-list__link-text">Перейти на сайт</span>
											<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
												<path d="M3.29289 10.2929L2.58579 11L4 12.4142L4.70711 11.7071L3.29289 10.2929ZM14.7071 1.70711C15.0976 1.31658 15.0976 0.683417 14.7071 0.292893C14.3166 -0.0976311 13.6834 -0.0976311 13.2929 0.292893L14.7071 1.70711ZM4.70711 11.7071L14.7071 1.70711L13.2929 0.292893L3.29289 10.2929L4.70711 11.7071Z" fill="#838DAA"/>
												<path d="M14 10V1H5" stroke="#838DAA" stroke-width="2" stroke-linecap="square" stroke-linejoin="round"/>
												<path d="M1 15L15 15" stroke="#838DAA" stroke-width="2" stroke-linecap="square" stroke-linejoin="round"/>
											</svg>
										</a>
									</div>
									<ul class="dealers-list__subitems">
										<li class="dealers-list__subitem" v-for="item in filteredTeceOffices" :key="item.ID">
											<p class="dealers-list__subtitle" :class="{'dealers-list__subtitle--sub': item.PROPERTIES.TYPE_OFFICE.VALUE !== '10'}">{{ item.PROPERTIES.TYPE_OFFICE.VALUE_ENUM }}</p>
											<p class="dealers-list__address">{{ item.PROPERTIES.STATE_OFFICE.VALUE }}, {{ item.PROPERTIES.CITY_OFFICE.VALUE }}, {{ item.PROPERTIES.STREET_OFFICE.VALUE }}</p>
											<a :href="'tel: ' + item.PROPERTIES.PHONE_OFFICE.VALUE" class="dealers-list__phone">
												{{ item.PROPERTIES.PHONE_OFFICE.VALUE }}
											</a>
										</li>
									</ul>
								</li>
							</ul>
						</div>
						<div class="dealers-list__wrapper" v-else>
							<ul class="dealers-list__list">
								<li class="dealers-list__item" v-for="item in filteredDealers" :key="item.ID" >
									<div class="dealers-list__title-wrapper">
										<p class="dealers-list__title">{{ item.NAME }}</p>
										<a v-if="item.UF_URL_SITE" target="_blank" :href="item.UF_URL_SITE" class="dealers-list__link">
											<span class="dealers-list__link-text">Перейти на сайт</span>
											<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
												<path d="M3.29289 10.2929L2.58579 11L4 12.4142L4.70711 11.7071L3.29289 10.2929ZM14.7071 1.70711C15.0976 1.31658 15.0976 0.683417 14.7071 0.292893C14.3166 -0.0976311 13.6834 -0.0976311 13.2929 0.292893L14.7071 1.70711ZM4.70711 11.7071L14.7071 1.70711L13.2929 0.292893L3.29289 10.2929L4.70711 11.7071Z" fill="#838DAA"/>
												<path d="M14 10V1H5" stroke="#838DAA" stroke-width="2" stroke-linecap="square" stroke-linejoin="round"/>
												<path d="M1 15L15 15" stroke="#838DAA" stroke-width="2" stroke-linecap="square" stroke-linejoin="round"/>
											</svg>
										</a>
									</div>
									<ul class="dealers-list__subitems">
										<li class="dealers-list__subitem" v-for="office in item.OFFICES" :key="office.ID">
											<p class="dealers-list__subtitle" :class="{'dealers-list__subtitle--sub': office.PROPERTIES.TYPE_OFFICE.VALUE !== '10'}">{{ office.PROPERTIES.TYPE_OFFICE.VALUE_ENUM }}</p>
											<p class="dealers-list__address">{{ office.PROPERTIES.STATE_OFFICE.VALUE }}, {{ office.PROPERTIES.CITY_OFFICE.VALUE }}, {{ office.PROPERTIES.STREET_OFFICE.VALUE }}</p>
											<a :href="'tel: ' + office.PROPERTIES.PHONE_OFFICE.VALUE" class="dealers-list__phone">
												{{ office.PROPERTIES.PHONE_OFFICE.VALUE }}
											</a>
										</li>
									</ul>
								</li>
							</ul>
						</div>
					</template>
				</div>
			</div>
		</div>
	`,

	components: {
		Select,
		BasicInputSearch,
		Map,
		AutocompleteAccrual
	},

	created() {
		this.isShared = window.TECE_URL === '/dealers/index.php';
		this.sortArrays();
		this.filteredTeceOffices = this.teceOffices;
		this.filteredDealers = this.dealers;
		this.dealerType === 'TECE' ? this.chosenOffices = this.filteredTeceOffices : this.chosenOffices = this.filteredDealers;
		const officesList = window.TECE.DILLERS.filter(item => item.OFFICES);
		let offices = [];
		officesList.forEach(item => {
			offices.push(item.OFFICES);
		});
		let citiesList = offices.flat().map((item) => item.PROPERTIES.CITY_OFFICE.VALUE).filter(office => office);
		let regionsList = offices.flat().map((item) => item.PROPERTIES.STATE_OFFICE.VALUE);
		this.availableLocations = [...citiesList, ...regionsList];
		this.sortClick();
	},

	methods: {
		changeLocation(location) {
			if(!location || !Object.keys(location).length) {
				this.filteredTeceOffices = this.teceOffices;
				this.filteredDealers = window.TECE.DILLERS.filter(dealer => dealer.NAME !== 'TECE');
			} else {
				let locationType;
				if(location.data.city_with_type) {
					locationType = location.data.city_with_type;
				} else {
					locationType = location.data.settlement_with_type || location.data.region_with_type;
				}
				this.$refs.dealerReset.inputData = '';
				this.filteredTeceOffices = this.teceOffices.filter(office => office.PROPERTIES.CITY_OFFICE.VALUE === locationType || office.PROPERTIES.STATE_OFFICE.VALUE === locationType);
				let dealersList = this.dealers.filter(dealer => dealer.OFFICES);
				let dealersListM = JSON.parse(JSON.stringify(dealersList));
				dealersListM.forEach(eachDealer => {
					eachDealer.OFFICES = eachDealer.OFFICES.filter(office => office.PROPERTIES.CITY_OFFICE.VALUE === locationType || office.PROPERTIES.STATE_OFFICE.VALUE === locationType);
				});
				this.filteredDealers = dealersListM.filter(filtered => filtered.OFFICES.length);
			}

			this.map && this.sortForMap();
		},

		sortForMap() {
			this.dealerType === 'TECE' ? this.chosenOffices = this.filteredTeceOffices : this.chosenOffices = this.filteredDealers;
		},

		sortArrays() {
			const sortOffices = (a, b) => {
				return a.PROPERTIES.TYPE_OFFICE.VALUE - b.PROPERTIES.TYPE_OFFICE.VALUE;
			};
			const teceDialer = window.TECE.DILLERS.find(item => item.NAME === 'TECE');
			this.teceOffices = teceDialer.OFFICES;
			this.teceOffices.sort((a, b) => sortOffices(a, b));
			this.teceOffices.forEach(item => {
				item.NAME = 'TECE';
				item.site = teceDialer.UF_URL_SITE;
			});
			this.dealers = window.TECE.DILLERS.filter(item => item.NAME !== 'TECE');
			this.dealers.forEach(item => {
				if (item.OFFICES && item.OFFICES.length) {
					item.OFFICES.sort((a, b) => sortOffices(a, b));

					if (item.UF_URL_SITE) {
						item.OFFICES.forEach(office => {
							office.site = item.UF_URL_SITE;
							office.NAME = item.NAME;
						});
					}
				}
			});
		},

		sortAscDescArrays(sortDirection) {
			this.filteredDealers.sort(function (a,b) {
				a = a.NAME.toLowerCase();
				b = b.NAME.toLowerCase();
				if (a < b) {
					if (sortDirection) {
						return -1;
					} else {
						return 1;
					}
				}
				if (a > b) {
					if (sortDirection) {
						return 1;
					} else {
						return -1;
					}
				}
				return 0;
			});
		},

		changeType(type) {
			this.dealerType = type;
			this.sortForMap();
		},

		switcher() {
			this.sortForMap();
			this.map = !this.map;
		},

		sortClick() {
			this.clicked = !this.clicked;
			this.sortAscDescArrays(this.clicked);
			this.map && this.sortForMap();
		},

		searchQuery(value) {
			this.$refs.autocomplete.inputData = '';
			if(!value.ID) {
				this.filteredDealers = this.dealers;
				this.changeType(this.dealerType);
			} else {
				if(value.ID === '32') {
					this.dealerType = 'TECE';
					this.filteredTeceOffices = this.teceOffices;
				} else {
					this.dealerType = 'Dealer';
					this.filteredDealers = this.dealers.filter(dealer => dealer.NAME === value.NAME);
				}
			}
			this.map && this.sortForMap();
		}
	}
});

import { BitrixVue } from 'ui.vue';

const app = BitrixVue.createApp({
	template: '<dealers-list/>'
});
app.mount('DealersList');
